const digest = '64d714b2972220fcaa16cc28a4a1f1a44d6ad639270c6002d9876954d715109e';
const css = `._emptyDay_2zcae_1{height:2.75rem;width:2.75rem}@media (max-width:767px){._emptyDay_2zcae_1{width:100%}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'emptyDay': '_emptyDay_2zcae_1' };
export const emptyDay = '_emptyDay_2zcae_1';
export { css, digest };